import { useTranslation } from 'react-i18next';
import { SEOHead } from '@/components/SEO/SEOHead';
import { HeroSection } from '@/components/home/HeroSection';
import { ServicesSection } from '@/components/home/ServicesSection';
import { TrustedByBanner } from '@/components/home/TrustedByBanner';
import { ArticlesSection } from '@/components/home/ArticlesSection';
import { WikiAgriTechSection } from '@/components/home/WikiAgriTechSection';
import { CTASection } from '@/components/home/CTASection';

export function HomePage() {
  const { t } = useTranslation('seo');

  return (
    <>
      <SEOHead
        title={t('home.title')}
        description={t('home.description')}
        path=""
      />
      <div>
        <HeroSection />
        <ServicesSection />
        <TrustedByBanner />
        <ArticlesSection />
        <WikiAgriTechSection />
        <CTASection />
      </div>
    </>
  );
}
